
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("@ember-data/store/index", function(){ return i("@ember-data/store/index.js");});
import "ember-cli-typescript/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-compatibility-helpers/-embroider-implicit-modules.js";
import "@ember/string/-embroider-implicit-modules.js";
import "@ember-data/canary-features/-embroider-implicit-modules.js";
import "ember-cached-decorator-polyfill/-embroider-implicit-modules.js";
import "@ember-data/private-build-infra/-embroider-implicit-modules.js";
import "@ember-data/store/-embroider-implicit-modules.js";
